import React, { ReactNode } from "react";
import { TickCircle, Warning } from "@asphalt-react/iconpack";
import { Text } from "src/components/Text";
import { Box } from "src/components/Box";
import { useTranslation } from "src/hooks/useTranslation";
import { MediaQueries } from "src/constants/MediaQueries";
import styled, { css, DefaultTheme } from "styled-components";

const BoxContainerEl = styled(Box)<Props>`
  margin: 0 -${(p) => p.theme.layout.margin.l}px;
  border-radius: 0;
  display: block;
  background-color: ${(props) => props.theme.colors.message[props.color!]};
  padding: ${(p) =>
    p &&
    css`
      ${p.theme.layout.margin.m}px ${p.theme.layout.margin.xl}px
    `};

  > div {
    flex: 1;
  }

  ${MediaQueries.screen.medium.minWidth} {
    margin: 0;
    border-radius: 8px;
  }
`;

const BoxAlertEl = styled(Box)<Props>`
  border-radius: 500px;
  padding: 2px 4px;
  background-color: ${(props) => props.theme.colors.background[props.color!]};
  width: fit-content;

  > svg {
    color: ${(p) => p.theme.colors.text.white};
    width: 14px;
    height: 14px;
  }
`;

interface Props {
  color?: keyof DefaultTheme["colors"]["message"];
  children: ReactNode;
}

export const BankInfoAlert = ({ color = "primary", children }: Props) => {
  const translate = useTranslation();

  const isColorDanger = color === "danger";

  return (
    <BoxContainerEl marginBottomL color={color}>
      <BoxAlertEl
        flex
        alignItemsCenter
        marginBottomL
        paddingVerticalS
        paddingHorizontalM
        color={color}
      >
        {isColorDanger ? <Warning /> : <TickCircle />}
        <Text marginLeftM fontSize="small" color="white">
          {isColorDanger
            ? translate("bank_info.validate.error")
            : translate("bank_info.validate.success")}
        </Text>
      </BoxAlertEl>
      <Box flex flexDirectionColumn>
        {children}
      </Box>
    </BoxContainerEl>
  );
};
